module.exports = {
  environment: {
    adminUrl: window.location.origin,
  }
}
